import { render, staticRenderFns } from "./ProductDetail_Drawings.vue?vue&type=template&id=5e764b16&scoped=true"
import script from "./ProductDetail_Drawings.vue?vue&type=script&lang=js"
export * from "./ProductDetail_Drawings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e764b16",
  null
  
)

export default component.exports